<template>
    <ul class="list-inline">
        <li v-for="(item, index) in data" :key="index" class="cl-bc-legend-item">
            <div :class="`cl-bc-legend-bullet colored-${item.shape}-${item.color}`" />
            {{ item.text }}
            <!-- @slot iball descriptor if item have a slot key -->
            <slot v-if="item.slot" :name="item.slot" />
            <slot v-if="item.IBallSlot" :name="item.IBallSlot" />
            <slot v-if="item.superscriptSlot" :name="item.superscriptSlot" />
        </li>
    </ul>
</template>

<script>
export default {
	name: 'HorizontalLegend',
	props: {
		data: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style scoped>
.cl-bc-legend-item {
    color: #666;
    font-size: 12px;
    line-height: 20px;
}

.cl-bc-legend-bullet {
    width: 10px;
    height: 10px;
    margin-right: 5px;
    display: inline-block;
}

.colored-circle-blue {
    background-color: #009adf;
    border-radius: 5px;
}

.colored-circle-gray {
    background-color: #ccc;
    border-radius: 5px;
}

.colored-square-blue {
    background-color: #009adf;
}

.colored-square-navy {
    background-color: #199BDD;
}

.colored-square-gray {
    background-color: #666;
}

@media (max-width: 768px) {
    .cl-bc-legend-item {
        display: block;
    }
}
</style>